// 占位图
const placehold = function (weidth, height, bgColor = "", text = "") {
  // return `http://www.ay1.cc/img?w=${weidth}&h=${height}&c=666666`
  return `https://iph.href.lu/${weidth}x${height}?bg=${bgColor}&text=${text}`;
};

const randomNum = function (minNum, maxNum) {
  switch (arguments.length) {
    case 1:
      return parseInt(Math.random() * minNum + 1, 10);
    case 2:
      return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
    default:
      return 0;
  }
};

const openUrl = function (name, $router, params, alias) {
  const fns = {
    1: function (path) {
      const obj = {
        title: alias || name,
        width: "80%",
        height: "80%",
        params: {},
      };
      if (path.includes(".html")) {
        obj.content = "DsfDialogIframe";
        obj.params.rmiframeUrl = path;
      } else {
        obj.params.path = path;
      }
      dsf.layer.openDialog(obj);
    },
    2: function () {
      $router.push({ path });
    },
    3: function () {
      dsf.layer.openWindow("./page.html#/pc/" + path, alias || name);
    },
  };
  if (dsf.config.setting_nameToPath[name]) {
    let path = dsf.config.setting_nameToPath[name];
    if (params) {
      Object.keys(params).map((key) => {
        path += `${path.indexOf("?") == -1 ? "?" : "&"}${key}=${params[key]}`;
      });
    }
    fns[dsf.config.setting_openMode](path);
  }
};

const directiveResize = function (Vue) {
  Vue.directive("resize", {
    // 指令的名称
    bind(el, binding) {
      // el为绑定的元素，binding为绑定给指令的对象
      let width = "",
        height = "";
      function isReize() {
        const style = document.defaultView.getComputedStyle(el);
        if (width !== style.width || height !== style.height) {
          binding.value(); // 关键
        }
        width = style.width;
        height = style.height;
      }
      el.__vueSetInterval__ = setInterval(isReize, 300);
    },
    unbind(el) {
      clearInterval(el.__vueSetInterval__);
    },
  });
};

module.exports = {
  placehold,
  randomNum,
  openUrl,
  directiveResize,
};
